import { render, staticRenderFns } from "./adAccountList.vue?vue&type=template&id=f4220cc4"
import script from "./adAccountList.vue?vue&type=script&lang=js"
export * from "./adAccountList.vue?vue&type=script&lang=js"
import style0 from "./adAccountList.vue?vue&type=style&index=0&id=f4220cc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports